import React, { useEffect, useRef, useState } from 'react';

const AdminHeader = ({ isLoading, handleRefreshClick, handleOpenEmailPopup, handleLogout }) => {
  const [isHeaderSticky, setIsHeaderSticky] = useState(false);
  const headerRef = useRef(null);

  // Add scroll event listener to check if header is sticky
  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const headerPosition = headerRef.current.getBoundingClientRect();
        setIsHeaderSticky(headerPosition.top === 0);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      ref={headerRef}
      className={`sticky top-0 z-10 bg-white transition-shadow duration-300 ${
        isHeaderSticky ? 'shadow-md' : ''
      }`}>
      <div className="container mx-auto py-6 px-4">
        <div className="flex flex-row justify-between items-center flex-wrap gap-6">
          {/* Left side - Heading and Subheading */}
          <div className="w-auto">
            <h1 className="text-2xl font-extrabold text-blue-10">PLATEFORME INSCRIPTION</h1>
            <p className="text-lg text-blue-10">GROUPES CNAT 2025</p>
          </div>

          {/* Right side - Buttons */}
          <div className="flex items-center space-x-4">
            <button
              className={`${isLoading ? 'animate-spin' : ''} bg-lightBlue-10 text-blue-10 hover:scale-105 active:scale-95 transition-all duration-300 p-3 rounded-full`}
              title="Refresh"
              onClick={handleRefreshClick}
              disabled={isLoading}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
            </button>
            {/* Only render the email button if the handler is provided */}
            {handleOpenEmailPopup && (
              <button
                className="bg-lightBlue-10 text-blue-10 hover:scale-105 active:scale-95 transition-all duration-300 p-3 rounded-full"
                title="Email"
                onClick={handleOpenEmailPopup}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </button>
            )}
            <button
              className="bg-lightRed-10 text-red-10 hover:scale-105 active:scale-95 transition-all duration-300 p-3 px-5 rounded-xl flex items-center gap-2"
              title="Logout"
              onClick={handleLogout}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              <span className="font-bold">DECONNEXION</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
